<template>
  <ckeditor v-model="data.description" :editor="editor" :config="editorConfig" />
</template>
<script>
import { reactive } from 'vue'
import ClassicEditor from '../Plugin/CKEditor/ckeditor.js'

export default {
  name: 'TaskEditor',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    //....
    const data = reactive({
      description: props.emailMessageModal,
    })
    return {
      data,
      editor: ClassicEditor,
      editorConfig: {
        // image2_disableResizer: true,
        // disableObjectResizing: true,
        // image_prefillDimensions: false,
        // disallowedContent: 'img{width,height}',
        // extraAllowedContent: 'img[width,height]',
        // image: {
        //   resizeOptions: [],
        // },
        toolbar: {
          items: [
            'heading',
            {
              // This drop-down has the icon disabled and a text label instead.
              label: 'Font',
              icon: false,
              items: [
                'bold',
                'italic',
                'fontSize',
                'fontColor',
                'fontBackgroundColor',
                'underline',
                'strikethrough',
              ],
            },
            {
              // This drop-down has the icon disabled and a text label instead.
              label: 'Format',
              icon: false,
              items: [
                'blockQuote',
                'bulletedList',
                'numberedList',
                'outdent',
                'indent',
              ],
            },
            '|',
            'imageInsert',
            'link',
            '|',
            // 'fontSize',
            // 'horizontalLine',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo',
            'sourceEditing',
          ],
        },
        language: 'en',
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
        },
        mediaEmbed: {
          previewsInData: true,
        },
        removePlugins: ['MediaEmbedToolbar'],
        simpleUpload: {
          // The URL that the images are uploaded to.
          uploadUrl: '/emailMass/uploadCKImage',
        },
        // headers: {
        //   'X-CSRF-TOKEN': 'CSFR-Token',
        //   Authorization: 'Bearer <JSON Web Token>'
        // },
      },
    }
  },
  methods: {
    onEditorReady(editor) {
      this.editor = editor
    },
    insertField(token) {
      this.editor.model.change((writer) => {
        writer.insertText(token, this.editor.model.document.selection.getFirstPosition())
      })
      this.editor.focus()
    },
  },
}
</script>
<style>
.ck-editor__editable {
  min-height: 120px;
  line-height: 1em;
}
.ck-editor__editable_inline {
    padding: 0 30px !important;
}
.ck-content p {
  /* line-height: 1.6 !important; */
  margin-bottom: 1em;
}
.ck-content img {
  max-width: 100% !important;
  width: auto !important;
  height: auto !important;
  width: unset;
  height: unset;
  display: block;
}
</style>
